import {
  Breadcrumb,
  Button,
  Checkbox,
  DatePicker,
  Flex,
  Modal,
  Popconfirm,
  Row,
  Spin,
  Tooltip,
  Tour,
  Typography,
} from "antd";
import React, { useContext, useEffect, useRef, useState } from "react";
import { ColumnComponent } from "../../components/ui";
import QuickbooksContext from "../../context/QuickbooksContext";
import LayoutContext from "../../context/LayoutContext";
import Table from "antd/es/table";
import { getSummaryColumns } from "../../utils/colums/summaryColumns";
import { InvoiceDrawer } from "../../components/collections/InvoiceDrawer";
import dayjs, { Dayjs } from "dayjs";
import DataContext from "../../context/DataContext";
import { useParams } from "react-router-dom";
import AuthContext from "../../context/AuthContext";
import {
  DownloadOutlined,
  MailOutlined,
  EditOutlined,
  QuestionCircleOutlined,
  PictureOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import { MultipleSelect, SearchInput } from "../../components/functional";
import { exportSummaryFile } from "../../utils/func/ExportFile";
import { ModalCollectionsBulkUpdate } from "../../components/collections";
import { USDollar } from "../../utils/func/currency";
import { SummaryDataProps, SummaryProps } from "../../interfaces/interfaces";
import type { TablePaginationConfig } from "antd/es/table";
import type { FilterValue } from "antd/es/table/interface";
import { TableProps, TourProps } from "antd/lib";
import { useDemoModal } from "../../hooks";
import * as htmlToImage from "html-to-image";
const { Text } = Typography;

type OnChange = NonNullable<TableProps<SummaryProps>["onChange"]>;

type GetSingle<T> = T extends (infer U)[] ? U : never;
type Sorts = GetSingle<Parameters<OnChange>[2]>;

interface TableParams {
  pagination?: TablePaginationConfig;
  sortField?: string;
  sortOrder?: string;
  filters?: Record<string, FilterValue>;
}

export const SummaryClient = () => {
  const { idClient } = useParams();
  const { clientInfo, isDemoEnv, profileInfo } = useContext(AuthContext);
  const { DemoModal, openModalDemo } = useDemoModal();
  const { setPageExtra } = useContext(LayoutContext);
  const [sortedInfo, setSortedInfo] = useState<Sorts>({});
  const {
    isInvoiceDrawerOpen,
    summaryData,
    invoiceListSelected,
    invoiceSelected,
    indexInvoiceSelected,
    selectedRowsToEdit,
    qbLoading,
    handleCancelSelectInvoiceList,
    getData,
    handleSelectInvoiceList,
    handleSelectInvoice,
    updateSelectedInvoice,
    onChangeSelectedRowsToEdit,
    handleBulkEdit,
    handleGetQbData,
    handleChangeFilters,
    onChangeSearchQuery,
    onDemandReminder,
  } = useContext(QuickbooksContext);
  const {
    getData: getListData,
    statusList,
    statusOptions,
    customerOptions,
    isTourOpen,
    handleTour,
    handleSuccess,
  } = useContext(DataContext);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [difference, setDifference] = useState({
    current: 0,
    total_1_30: 0,
    total_31_60: 0,
    total_61_90: 0,
    total_90: 0,
    gran_total: 0,
  });
  const [openModal, setOpenModal] = useState(false);
  const [modalBody, setModalBody] = useState(<></>);
  const [dataTableSize] = useState<number>(100);
  const [summaryList, setSummaryList] = useState<SummaryProps[]>([]);
  const [tableParams, setTableParams] = useState<TableParams>({});
  const [customerSelected, setCustomerSelected] = useState([]);
  const [statusSelected, setStatusSelected] = useState([]);
  const [nextFollowUpDate, setNextFollowUpDate] = useState<Dayjs | null>(null);
  const [hasFollowUpDate, setHasFollowUpDate] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [hasIgnored, setHasIgnored] = useState(false);
  const [internalLoading, setInternalLoading] = useState(false);
  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);
  const ref4 = useRef(null);
  const ref5 = useRef(null);
  const ref6 = useRef(null);
  const ref7 = useRef(null);
  const ref8 = useRef(null);
  const ref9 = useRef(null);
  const screenRef = useRef(null);
  const hasFetched = useRef(false);

  useEffect(() => {
    if (idClient && !hasFetched.current) {
      hasFetched.current = true;
      getListData("status", idClient);
      getListData("customer", idClient);
      getData({
        endpoint: "summary",
        idClient,
      });
    }
    return () => {
      hasFetched.current = true;
    };
  }, [idClient]);

  useEffect(() => {
    onChangeSearchQuery("");
    setSearchQuery("");
    if (isDemoEnv) {
      let tourOpened = localStorage.getItem("tour-summary");
      if (!tourOpened) {
        handleTour(true);
        localStorage.setItem("tour-summary", "true");
      }
    }
  }, []);

  useEffect(() => {
    const defaultSortKey = profileInfo?.preferences?.collections?.summary
      ?.defaultSortColumnKey || { name: "Total", order: "ascend" };
    setSortedInfo({
      columnKey: defaultSortKey.name,
      order: defaultSortKey.order as "ascend" | "descend",
    });
  }, [profileInfo]);

  useEffect(() => {
    setTableParams({
      pagination: {
        pageSize: dataTableSize,
        total: summaryData.data.length,
        onChange: (_, pageSize) => {
          setTableParams((prev) => {
            return {
              ...prev,
              pagination: {
                ...prev.pagination,
                pageSize: pageSize,
              },
            };
          });
        },
      },
    });
    setSummaryList(summaryData.data);
    customerSelected.length === 0 &&
      statusSelected.length === 0 &&
      searchQuery === "" &&
      !hasIgnored &&
      getDifferences(summaryData);
  }, [summaryData]);

  useEffect(() => {
    if (!isDemoEnv) {
      setPageExtra(
        <>
          {summaryData.lastUpdate &&
            summaryData.lastUpdate?.CollectionsDate && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  gap: "2px",
                }}
              >
                <Text
                  style={{
                    color: "var(--slate-400)",
                    fontSize: "0.65rem",
                    fontWeight: 700,
                    letterSpacing: "0.5px",
                    textTransform: "uppercase",
                    lineHeight: 1,
                  }}
                >
                  Last Synced
                </Text>
                <Text
                  style={{
                    color: "var(--slate-700)",
                    fontSize: "0.875rem",
                    fontWeight: 600,
                    lineHeight: 1.2,
                  }}
                >
                  {dayjs
                    .utc(summaryData.lastUpdate.CollectionsDate)
                    .format("MMM DD, YYYY, h:mm A")}
                </Text>
              </div>
            )}
          <Button
            type="primary"
            icon={<SyncOutlined />}
            style={{
              backgroundColor: "#2b8cee",
              borderColor: "#2b8cee",
              fontWeight: 600,
              fontSize: "0.875rem",
              height: "auto",
              padding: "8px 20px",
              borderRadius: "20px",
            }}
            loading={qbLoading}
            onClick={() =>
              idClient &&
              handleGetQbData(idClient, () => {
                getData({
                  endpoint: "summary",
                  idClient,
                  filters: {
                    customer:
                      customerSelected.length > 0 ? customerSelected : null,
                    status: statusSelected.length > 0 ? statusSelected : null,
                  },
                });
                idClient &&
                  getData({
                    endpoint: "summary",
                    idClient,
                  });
              })
            }
          >
            Refresh From QuickBooks
          </Button>
        </>,
      );
    } else {
      setPageExtra(null);
    }

    return () => {
      setPageExtra(null);
    };
  }, [
    clientInfo,
    isDemoEnv,
    summaryData,
    qbLoading,
    idClient,
    customerSelected,
    statusSelected,
  ]);

  const rowSelectionToEdit = {
    selectedRowKeys: selectedRowsToEdit,
    onChange: onChangeSelectedRowsToEdit,
    selections: [Table.SELECTION_ALL, Table.SELECTION_NONE],
  };

  const handleChange: OnChange = (pagination, filters, sorter) => {
    setSortedInfo(sorter as Sorts);
  };

  const getDifferences = (summaryData: SummaryDataProps) => {
    const totals = sessionStorage.getItem("totals")
      ? JSON.parse(sessionStorage.getItem("totals") || "")
      : null;
    if (totals && totals.clientId === idClient && totals.gran_total) {
      let newDiff = {
        current: totals.current - summaryData.total.current,
        total_1_30: Math.round(totals.total_1_30 - summaryData.total["1-30"]),
        total_31_60: Math.round(
          totals.total_31_60 - summaryData.total["31-60"],
        ),
        total_61_90: Math.round(
          totals.total_61_90 - summaryData.total["61-90"],
        ),
        total_90: Math.round(totals.total_90 - summaryData.total[">90"]),
        gran_total: Math.round(totals.gran_total - summaryData.total.total),
      };
      let listOfTotals: any[] = [];
      Object.entries(newDiff).forEach(([key, value], index) => {
        if (value > 0 || value < 0) {
          listOfTotals.push({
            label:
              key === "current"
                ? "Current A/R"
                : key === "total_1_30"
                  ? "1-30 A/R"
                  : key === "total_31_60"
                    ? "31-60 A/R"
                    : key === "total_61_90"
                      ? "61-90 A/R"
                      : key === "total_90"
                        ? ">90 A/R"
                        : "Total",
            value: USDollar.format(value),
            index,
          });
        }
      });
      setDifference(newDiff);
      if (listOfTotals.length > 0) {
        setModalBody(
          <>
            Discrepancy identified,
            <span>
              {" "}
              Please review the following values, as they differ from those in
              QuickBooks.
            </span>
            <ul>
              {listOfTotals.map((line: any) => (
                <React.Fragment key={line?.index}>
                  {line?.value && (
                    <div>
                      <strong>{line?.label}: </strong>
                      <span>{line?.value}</span>
                    </div>
                  )}
                </React.Fragment>
              ))}
            </ul>
          </>,
        );
        setOpenModal(true);
      } else {
        setOpenModal(false);
        localStorage.removeItem("totals");
      }
    } else {
      setDifference({
        current: 0,
        total_1_30: 0,
        total_31_60: 0,
        total_61_90: 0,
        total_90: 0,
        gran_total: 0,
      });
    }
  };

  const sendMultipleReminder = () => {
    if (isDemoEnv) {
      openModalDemo();
    } else {
      if (clientInfo && selectedRowsToEdit.length > 0) {
        onDemandReminder({
          idClient: clientInfo._id,
          customerList: selectedRowsToEdit as string[],
          next: () => {
            clientInfo &&
              idClient &&
              handleBulkEdit({
                endpoint: "invoice-customer",
                idClient: idClient,
                items: selectedRowsToEdit as string[],
                newStatus: {
                  Status: null,
                  LastContact: dayjs(),
                  NewNote: "Invoices Notification sent",
                  NextFollowUp: null,
                },
                next: () =>
                  getData({
                    endpoint: "summary",
                    idClient,
                    filters: {
                      customer:
                        customerSelected.length > 0 ? customerSelected : null,
                      status: statusSelected.length > 0 ? statusSelected : null,
                    },
                  }),
              });
          },
        });
      }
    }
  };

  const steps: TourProps["steps"] = [
    {
      title: "Toolbar",
      description:
        "This is the toolbar, where you can find all the actions, filters, and export options.",
      target: () => ref1.current,
    },
    {
      title: "As of Date",
      description: "This is the date of the A/R Aging Summary.",
      target: () => ref2.current,
    },
    {
      title: "Edit Single/Multiple Invoice(s)",
      description:
        "Edit the status, email address, phone number of one or multiple invoices by customer at once.",
      target: () => ref3.current,
    },
    {
      title: "Take screenshot",
      description:
        "Take an screenshot of the A/R Summary and copy it to the clipboard.",
      target: () => ref9.current,
    },
    {
      title: "Send Aging Listing",
      description:
        "Send an email listing all due Invoices to the selected customer(s) with overdue invoices.",
      target: () => ref4.current,
    },
    {
      title: "Export Data",
      description: "Export the A/R Aging Summary data to a CSV file.",
      target: () => ref5.current,
    },
    {
      title: "Filter By Status",
      description: "Filter the A/R Aging Summary by status.",
      target: () => ref6.current,
    },
    {
      title: "Filter By Customer",
      description: "Filter the A/R Aging Summary by customer.",
      target: () => ref7.current,
    },
    {
      title: "A/R Summary",
      description: "This is the A/R Aging Summary by customer.",
      target: () => ref8.current,
    },
  ];

  const hasSelected = selectedRowsToEdit.length > 0;

  const handleScreenshot = async () => {
    if (!screenRef.current) return;
    setInternalLoading(true);
    setTimeout(() => {
      htmlToImage
        .toBlob(document.getElementById("screenshot") as HTMLElement)
        .then(async function (blob) {
          if (!blob) return;
          await navigator.clipboard.write([
            new ClipboardItem({ "image/png": blob }),
          ]);
          handleSuccess(false, "Failed to copy screenshot. Try again.");
          setInternalLoading(false);
        });
      handleSuccess(true, "Screenshot copied to clipboard");
    }, 500);
  };

  return (
    <>
      <Breadcrumb
        style={{ marginBottom: "16px" }}
        items={[{ title: "Home" }, { title: "A/R Aging Summary" }]}
      />
      <Row gutter={[24, 0]}>
        <ColumnComponent>
          <div ref={ref1}>
            <div className="summary-client__filters-container">
              <div className="summary-client__filters-row">
                {/* Actions Section */}
                <div className="filter-group">
                  <label className="filter-label">Actions</label>
                  <div className="filter-actions">
                    <div ref={ref3}>
                      <Tooltip title="Edit">
                        <Button
                          type="text"
                          icon={<EditOutlined style={{ fontSize: "18px" }} />}
                          disabled={!hasSelected}
                          size="large"
                          onClick={() => setIsEditModalOpen(true)}
                          className="action-btn"
                        />
                      </Tooltip>
                    </div>
                    <div ref={ref9}>
                      <Tooltip title="Take Screenshot">
                        <Button
                          type="text"
                          icon={
                            <PictureOutlined style={{ fontSize: "18px" }} />
                          }
                          size="large"
                          loading={internalLoading}
                          onClick={handleScreenshot}
                          className="action-btn"
                        />
                      </Tooltip>
                    </div>
                    <div ref={ref4}>
                      <Tooltip title="Send Aging Listing">
                        <Popconfirm
                          title="Send Aging Listing?"
                          onConfirm={sendMultipleReminder}
                        >
                          <Button
                            type="text"
                            disabled={!(selectedRowsToEdit.length > 0)}
                            loading={qbLoading}
                            icon={<MailOutlined style={{ fontSize: "18px" }} />}
                            size="large"
                            className="action-btn"
                          />
                        </Popconfirm>
                      </Tooltip>
                    </div>
                    <div ref={ref5}>
                      <Tooltip
                        title={
                          selectedRowsToEdit.length > 0
                            ? "Export Selected Data"
                            : "Export Data"
                        }
                      >
                        <Button
                          type="text"
                          icon={
                            <DownloadOutlined style={{ fontSize: "18px" }} />
                          }
                          size="large"
                          onClick={() => {
                            exportSummaryFile(
                              summaryData,
                              selectedRowsToEdit as string[],
                            );
                          }}
                          className="action-btn"
                        />
                      </Tooltip>
                    </div>
                  </div>
                </div>

                {/* Filter by Status */}
                <div className="filter-group" ref={ref6}>
                  <span
                    style={{
                      fontSize: "14px",
                      color: "#6b7280",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Status:
                  </span>
                  <MultipleSelect
                    placeholder="All"
                    className="filter-select"
                    options={statusOptions}
                    onSelect={(values) => {
                      setStatusSelected(values as any);
                      idClient &&
                        handleChangeFilters(
                          "summary",
                          idClient,
                          "status",
                          values,
                        );
                    }}
                  />
                </div>

                {/* Filter by Customer */}
                <div className="filter-group" ref={ref7}>
                  <span
                    style={{
                      fontSize: "14px",
                      color: "#6b7280",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Customer:
                  </span>
                  <MultipleSelect
                    placeholder="All"
                    className="filter-select"
                    options={customerOptions}
                    onSelect={(values) => {
                      setCustomerSelected(values as any);
                      idClient &&
                        handleChangeFilters(
                          "summary",
                          idClient,
                          "customer",
                          values,
                        );
                    }}
                  />
                </div>

                {/* Next Follow Up Date */}
                <div className="filter-group filter-followup">
                  <Tooltip title="Show only invoices with a follow up date">
                    <Checkbox
                      checked={hasFollowUpDate}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        setHasFollowUpDate(checked);
                        if (checked) {
                          setNextFollowUpDate(null);
                          if (idClient) {
                            handleChangeFilters(
                              "summary",
                              idClient,
                              "nextFollowUp",
                              ["any"],
                            );
                          }
                        } else {
                          if (idClient) {
                            handleChangeFilters(
                              "summary",
                              idClient,
                              "nextFollowUp",
                              [],
                            );
                          }
                        }
                      }}
                    />
                  </Tooltip>
                  <span
                    style={{
                      fontSize: "14px",
                      color: "#6b7280",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Follow Up:
                  </span>
                  <DatePicker
                    className="modern-date-picker filter-date-picker"
                    format="MMM DD, YYYY"
                    placeholder="Select date"
                    value={nextFollowUpDate}
                    disabled={hasFollowUpDate}
                    onChange={(date) => {
                      setNextFollowUpDate(date);
                      if (date && idClient) {
                        setHasFollowUpDate(false);
                        handleChangeFilters(
                          "summary",
                          idClient,
                          "nextFollowUp",
                          [date.format("YYYY-MM-DD")],
                        );
                      } else if (!date && idClient) {
                        handleChangeFilters(
                          "summary",
                          idClient,
                          "nextFollowUp",
                          [],
                        );
                      }
                    }}
                    allowClear
                  />
                </div>

                {/* Search */}
                <div className="filter-group">
                  <div className="filter-search">
                    <SearchInput
                      placeholder="Search clients or invoices..."
                      onSearch={(value: string) => {
                        if (value) {
                          setSearchQuery(value);
                          idClient &&
                            getData({
                              endpoint: "summary",
                              idClient,
                              search: value,
                            });
                        } else {
                          setSearchQuery("");
                          idClient &&
                            getData({ endpoint: "summary", idClient });
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ColumnComponent>
        <ColumnComponent>
          <div
            ref={screenRef}
            id="screenshot"
            style={{
              borderRadius: "12px",
              overflow: "hidden",
              background: "white",
            }}
          >
            {qbLoading ? (
              <div
                style={{
                  minHeight: "25vw",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Flex gap="middle" align="center" vertical>
                  <Spin size="large" />
                </Flex>
              </div>
            ) : (
              <Table
                bordered
                columns={getSummaryColumns({
                  onCellClick: handleSelectInvoiceList,
                  sortedInfo,
                  summaryColumns:
                    profileInfo?.preferences?.collections?.summary.columns,
                })}
                onChange={handleChange}
                rowSelection={rowSelectionToEdit}
                dataSource={summaryList}
                className="summary-client__table"
                pagination={tableParams.pagination}
                size="small"
                rowKey={"idClient"}
                scroll={{ y: "70vh", x: "100%" }}
                tableLayout="auto"
                summary={() => (
                  <>
                    {summaryData.total && (
                      <Table.Summary.Row className="table-row">
                        <Table.Summary.Cell index={0}></Table.Summary.Cell>
                        <Table.Summary.Cell index={0}>
                          <strong>Total</strong>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={0}>
                          <span
                            style={{
                              color: difference.current !== 0 ? "red" : "green",
                            }}
                          >
                            {USDollar.format(summaryData.total.current)}
                          </span>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={0}>
                          <span
                            style={{
                              color:
                                difference.total_1_30 !== 0 ? "red" : "green",
                            }}
                          >
                            {USDollar.format(summaryData.total["1-30"])}
                          </span>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={0}>
                          <span
                            style={{
                              color:
                                difference.total_31_60 !== 0 ? "red" : "green",
                            }}
                          >
                            {USDollar.format(summaryData.total["31-60"])}
                          </span>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={0}>
                          <span
                            style={{
                              color:
                                difference.total_61_90 !== 0 ? "red" : "green",
                            }}
                          >
                            {USDollar.format(summaryData.total["61-90"])}
                          </span>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={0}>
                          <span
                            style={{
                              color:
                                difference.total_90 !== 0 ? "red" : "green",
                            }}
                          >
                            {USDollar.format(summaryData.total[">90"])}
                          </span>
                        </Table.Summary.Cell>
                        {profileInfo?.preferences?.collections?.summary.columns.includes(
                          "unbilledTime",
                        ) && (
                          <Table.Summary.Cell
                            index={0}
                            className="align-right table-row"
                          >
                            <span>{"-"}</span>
                          </Table.Summary.Cell>
                        )}
                        {profileInfo?.preferences?.collections?.summary.columns.includes(
                          "lastPayment",
                        ) && (
                          <Table.Summary.Cell
                            index={0}
                            className="align-right table-row"
                          >
                            <span>{"-"}</span>
                          </Table.Summary.Cell>
                        )}
                        <Table.Summary.Cell index={0}>
                          <span
                            style={{
                              color:
                                difference.gran_total !== 0 ? "red" : "green",
                            }}
                          >
                            {USDollar.format(summaryData.total.total)}
                          </span>
                        </Table.Summary.Cell>
                      </Table.Summary.Row>
                    )}
                  </>
                )}
              />
            )}
          </div>
        </ColumnComponent>
        <ColumnComponent>
          <div style={{ textAlign: "right", marginTop: "16px" }}>
            <Tooltip title="Help">
              <Button
                icon={
                  <QuestionCircleOutlined
                    style={{ color: "var(--primary)", fontSize: "18px" }}
                  />
                }
                type="default"
                size="large"
                onClick={() => {
                  handleTour(true);
                }}
                style={{
                  borderRadius: "8px",
                  transition: "all 0.3s ease",
                }}
              />
            </Tooltip>
          </div>
        </ColumnComponent>
      </Row>

      <InvoiceDrawer
        title={`Collections (${invoiceSelected.TransactionType} ${
          indexInvoiceSelected + 1
        } of ${invoiceListSelected.length})`}
        open={isInvoiceDrawerOpen}
        onClose={handleCancelSelectInvoiceList}
        invoice={invoiceSelected}
        options={statusList}
        idClient={idClient}
        indexInvoiceSelected={indexInvoiceSelected}
        list={invoiceListSelected}
        selectInvoice={(indexSelected) => handleSelectInvoice(indexSelected)}
        onClickNext={
          indexInvoiceSelected < invoiceListSelected.length - 1
            ? () => handleSelectInvoice(indexInvoiceSelected + 1)
            : undefined
        }
        onClickPrevious={
          indexInvoiceSelected !== undefined && indexInvoiceSelected > 0
            ? () => handleSelectInvoice(indexInvoiceSelected - 1)
            : undefined
        }
        onSubmit={(newNote, emailAddress, phoneNumber, newDate, next) => {
          if (isDemoEnv) {
            openModalDemo();
          } else {
            idClient &&
              updateSelectedInvoice(
                idClient,
                {
                  newNote,
                  emailAddress,
                  phoneNumber,
                  newDate,
                },
                () => next && next(),
              );
          }
        }}
      />
      <ModalCollectionsBulkUpdate
        title="Edit All Invoices for Selected Customer(s)"
        isModalOpen={isEditModalOpen}
        onSubmit={(values) => {
          if (isDemoEnv) {
            openModalDemo();
          } else {
            clientInfo &&
              idClient &&
              handleBulkEdit({
                endpoint: "invoice-customer",
                idClient: idClient,
                items: selectedRowsToEdit as string[],
                newStatus: values,
                next: () => {
                  onChangeSelectedRowsToEdit([]);
                  // if (idClient)
                  //   handleChangeFilters(
                  //     "summary",
                  //     idClient,
                  //     "customer",
                  //     customerSelected,
                  //   );
                },
              });
          }
          setIsEditModalOpen(false);
        }}
        onCancel={() => {
          setIsEditModalOpen(false);
        }}
      />
      <Modal
        open={openModal}
        onOk={() =>
          idClient &&
          handleGetQbData(idClient, () =>
            getData({
              endpoint: "summary",
              idClient,
              filters: {
                customer: customerSelected.length > 0 ? customerSelected : null,
                status: statusSelected.length > 0 ? statusSelected : null,
              },
            }),
          )
        }
        onCancel={() => setOpenModal(false)}
        footer={[
          <Button
            key="back"
            onClick={() => {
              setOpenModal(false);
              sessionStorage.removeItem("totals");
              setDifference({
                current: 0,
                total_1_30: 0,
                total_31_60: 0,
                total_61_90: 0,
                total_90: 0,
                gran_total: 0,
              });
              setHasIgnored(true);
            }}
          >
            Ignore
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={() =>
              idClient &&
              handleGetQbData(idClient, () =>
                getData({
                  endpoint: "summary",
                  idClient,
                  filters: {
                    customer:
                      customerSelected.length > 0 ? customerSelected : null,
                    status: statusSelected.length > 0 ? statusSelected : null,
                  },
                }),
              )
            }
          >
            Retry
          </Button>,
        ]}
      >
        {modalBody}
      </Modal>
      <Tour open={isTourOpen} onClose={() => handleTour(false)} steps={steps} />
      <DemoModal />
    </>
  );
};
